import styled from 'styled-components'

export const StyledIcon = styled.img`
  ${({ width }) => width && `max-width: ${width}`}
  ${({ height }) => height && `max-height: ${height}`}
  height: auto;
`
